<template>
  <v-btn large :width="width">
    <template v-if="icon">
      <v-img
        alt="TCDC_LOGO"
        class="shrink ml-3"
        contain
        src="@/assets/google_icon.png"
        transition="scale-transition"
        width="30px"
      />
    </template>
    {{label}}
  </v-btn>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: Boolean,
    },
    width: {
      type: String,
      default: '100%',
    },
  },
  name: 'LoginButton',
};
</script>

<style lang="scss" scoped>
  @import "src/assets/css/variables.scss";
  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
    background-color: #ffffff;
    color: black;
    display:block;
    border-radius: 20px;
    border: 1px solid $background-theme;
    height: 40px;
  }
</style>
